<!-- 密码验证 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">
			{{title}}
		</template>
		<div style="padding-top: 30px;">
			<div class="formContainer">
				<label><span class="required">*</span>登录密码</label>
				<input type="password" v-model.trim="verifyPassword" autocomplete="new-password" placeholder="请输入登录密码" />
			</div>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: {
			
		},
		data() {
			return {
				title: '',
				callback: undefined,
				verifyPassword: ''
			}
		},
		computed: {
			
		},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if(this.verifyPassword == '' || this.verifyPassword == undefined){
					return
				}
				if(this.callback != undefined){
					this.callback(hex_md5(this.verifyPassword))
					this.verifyPassword = ''
				}
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.verifyPassword = ''
				this.$refs.body.hide()
			},
			open(title, callBack) {
				this.title = title
				this.callback = callBack
				this.$refs.body.open()
			},
		}
	}
</script>
<style scoped>
	.formContainer{
		margin-bottom: 12px;
	}
	
	.formContainer>label{
		min-width: 72px;
		text-align: right;
		display: inline-block;
		margin-right: 12px;
		line-height: 32px;
	}
	
	.formContainer>label>span{
		display: inline-block;
		width: 8px;
	}
	
	.required{
		color: red;
	}
</style>